<template>
  <div class="component">

    <div class="container" :class="{active: party.active, inactive: !party.active}">
      <label>
        <input type="checkbox" v-model="party.active">{{party.name}}
      </label>
    </div>
    <!--label>
      <input type="hidden" v-model="anySelected">
      <strong>{{party.name}}</strong>
    </label>

    <div v-for="feed in party.feeds">
      <label>
        <input type="checkbox" v-model="feed.active">{{feed.name}}
      </label>
    </div-->

  </div>
</template>

<script>
export default {
  name: 'FeedFacebook',
  data () {
    return {
    }
  },
  props: {
    party: ""
  },
  methods: {
  },
  computed: {
    anySelected: function () {
      this.party.active = !this.party.feeds.every(function(feed){
        return !feed.active;
      });
      return this.party.active;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .component{
    color: black;
  }

  .container{
    padding: 0px 5px 0px 5px;
    border-radius: 5px;
    font-weight: 500;
  }

  .active{
    background: rgba(255,255,255,1);

  }

  .inactive{
    background: rgba(255,255,255,0.5);
    color: gray;
  }

  label{
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/components/PartyCheck.vue